export const CHANGE_PARTNER_EVENT = 'changePartnerEvent';
export const CLOSE_PARTNER_MENU_EVENT = 'closePartnerMenuEvent';
